import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-vessel-builder-select-list',
    templateUrl: './vessel-builder-select-list.component.html',
    styleUrls: ['./vessel-builder-select-list.component.scss'],
    standalone: false
})
export class VesselBuilderSelectListComponent {
    searchText: string;

    filteredBuilders: any[];

    constructor(
        public dialogRef: MatDialogRef<VesselBuilderSelectListComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.filteredBuilders = data;
    }

    filterBuilders(event) {
        const searchText = event.currentTarget.value.toLowerCase();
        this.filteredBuilders = this.data.filter((builder) =>
            builder.name.toLowerCase().includes(searchText),
        );
    }

    rowClick = (p) => {
        this.dialogRef.close(p);
    };
}
